import {Injectable, Injector} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from './auth/auth.service';
import {DefibrillatorProperty, DefibrillatorUpdatedData} from 'app/shared/models/defibrillatorUpdatedData.model';
import {KeycloakService} from './device-management/keycloak.service';
import {UserRole} from '../../shared/enums/user-role.enum';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserItem} from '../../shared/models/device-management/UserItem';

/**
 * Service providing ekg values
 */
@Injectable({
  providedIn: 'root'
})
export class DefibrillatorService {

  private cbrokerEndpoint = null;
  private ingestionEndpoint = null;
  private keycloakService = null;

  constructor(private injector: Injector,
              private httpClient: HttpClient,
              private authService: AuthService) {

    this.cbrokerEndpoint = `${environment.server.contextBrokerApi}/realms/${this.authService.getRealmId()}/ngsi-ld/v1`;
    this.ingestionEndpoint = `${environment.server.ingestionApi}/${this.authService.getRealmId()}/ngsi-ld/v1`;
    this.keycloakService = injector.get(KeycloakService);
  }

  /**
   * Get ekg values
   */
  getEkgValues(entityId: any, startTime: any, endTime: any, cBrokerEndpoint: string = null) {
    const entityType = 'HealthCase';
    const attributes = 'ekgData';

    let urlParameter = '?type=' + entityType;
    urlParameter += '&id=' + entityId;

    if (attributes && attributes.length > 0) {
      urlParameter += '&attrs=' + attributes;
    }

    urlParameter += '&timerel=between&time=' + startTime;

    urlParameter += '&endTime=' + endTime;


    const url: string = cBrokerEndpoint ? `${cBrokerEndpoint}/temporal/entities${urlParameter}` : `${this.cbrokerEndpoint}/temporal/entities${urlParameter}`;
    return this.httpClient.get(url);
  }
  updateDefibrillatorInfo(updatedData: DefibrillatorUpdatedData): Observable<any> {
    const id = updatedData.id || ''; // fallback if needed
    const entityId = `urn:ngsi-ld:Defibrillator:${id}`;
    const url = `${this.ingestionEndpoint}/temporal/entities/${entityId}/attr`;

    const transformedData: any = {
      id: entityId,
      type: updatedData.type,
    };

    updatedData.updatedProperties.forEach(item => {
      transformedData[item.field] = [{
        type: item.type,
        value: item.value
      }];
    });

    return this.httpClient.post(url, transformedData);
  }
  checkEkgData(entityId: any) {
    const entityType = 'HealthCase';
    const attributes = 'ekgData';

    let urlParameter = '?type=' + entityType;
    urlParameter += '&id=' + entityId;

    if (attributes && attributes.length > 0) {
      urlParameter += '&attrs=' + attributes;
    }

    const url: string = `${this.cbrokerEndpoint}/entities${urlParameter}`;
    return this.httpClient.get(url);
  }

  getUserAttributes(realmId: string): Observable<string[]> {
    return this.keycloakService
      .getUsersForRealmAndRole(this.authService.getRealmId(), UserRole.REGULAR_USER, realmId ? realmId : this.authService.getRealmId())
      .pipe(
        map((userItems: UserItem[]) => {
          const companyInfos: string[] = [];
          userItems.forEach(user => {
            const companyId = user.attributes['companyId'];
            const companyName = user.attributes['companyName'];
            if (companyId?.length && companyName?.length) {
              const info: string = `${companyId[0]}-${companyName[0]}`;
              if (!companyInfos.includes(info)) {
                companyInfos.push(info);
              }
            }
          });
          return companyInfos;
        })
      );
  }
}
